'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _publishers = require('../publishers/publishers');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl, publisher) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
    this.publisher = publisher;

    if (!this.publisher) {
      this.publisher = (0, _publishers.getPublisherByType)();
    }
  }

  _createClass(Reporter, [{
    key: 'getBaseUrl',
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: 'getPublisher',
    value: function getPublisher() {
      return this.publisher;
    }
  }, {
    key: 'report',
    value: function report(data) {
      if (!data) {
        return null;
      }

      return this.publisher(this.baseUrl, data);
    }
  }]);

  return Reporter;
}();

exports.default = Reporter;


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/reporter/reporter.js
// module id = 273
// module chunks = 0